import angular from 'angular'

import playQueueService from 'common/play-queue.service.js'

import component from './scene-player-log.component'

export default angular.module('scene-player-log', [
  playQueueService
])
  .component('scenePlayerLog', component)
